import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/leads/contractsSentReportActions'
import * as api from '../../../api/reports/leads/contractsSentReport'

function* contractsSentGetLeadList(action) {
  try {
    const payload = yield call(api.getLeadList, action.filters)
    yield put({ type: constants.CONTRACTS_SENT_REPORT_GET_LEAD_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CONTRACTS_SENT_REPORT_GET_LEAD_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* contractsSentGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList, action.filters)
    yield put({ type: constants.CONTRACTS_SENT_REPORT_GET_ORGANIZATION_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CONTRACTS_SENT_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* contractsSentReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.CONTRACTS_SENT_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CONTRACTS_SENT_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchcontractsSentGetLeadList() {
  yield takeLatest(constants.CONTRACTS_SENT_REPORT_GET_LEAD_LIST.ACTION, contractsSentGetLeadList)
}

function* watchcontractsSentGetOrganizationList() {
  yield takeLatest(
    constants.CONTRACTS_SENT_REPORT_GET_ORGANIZATION_LIST.ACTION,
    contractsSentGetOrganizationList
  )
}

function* watchcontractsSentReportGetFullReport() {
  yield takeLatest(
    constants.CONTRACTS_SENT_REPORT_GET_FULL_REPORT.ACTION,
    contractsSentReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchcontractsSentGetOrganizationList),
    fork(watchcontractsSentReportGetFullReport),
    fork(watchcontractsSentGetLeadList)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/leads/contractsSentSaga.js